/**
 * Every page of a list, for a screen that shows all of something in hand at
 * once: the shipping desk, the logistics column, a bench's queue. Section 25 of
 * the review of 2 October 2026: those screens asked for one page of two hundred
 * and silently showed nothing past it.
 *
 * Bounded, so a filter that matched far more than any screen should hold
 * cannot turn one refetch into a hundred requests. `total` stays the server's,
 * so a screen can tell when it was cut.
 */
export const EVERY_PAGE_SIZE = 200;
export const MAX_PAGES = 10;

export async function everyPage<T, P extends { items: T[]; total: number }>(
  fetchPage: (page: number) => Promise<P>,
): Promise<P> {
  const first = await fetchPage(1);
  const items = [...first.items];

  for (let page = 2; page <= MAX_PAGES && items.length < first.total; page++) {
    const next = await fetchPage(page);
    if (next.items.length === 0) break;
    items.push(...next.items);
  }

  return { ...first, items };
}
